export default __webpack_public_path__ + "static/media/DogByte_Logo.0990fa7f.svg";